<app-layout-dialogheader1 [title]="'Add new user'" [titlesub]="" mat-dialog-title>

</app-layout-dialogheader1>

<mat-dialog-content>

  <app-user-edit #editform [ismodal]="true" [showheader]="false" [model]="model"></app-user-edit>

</mat-dialog-content>
<div mat-dialog-actions style="width:100%;" class="justify-content-end">
  <mat-progress-bar mode="indeterminate" *ngIf="submitted"></mat-progress-bar>
  <button mat-raised-button type="button" (click)="saveModel()" [disabled]="!isvalid()||submitted"
    class="btn btn-success ">Save</button>
  <button mat-raised-button mat-dialog-close class="btn ">Close</button>

</div>